import Organizations from './Organizations.container';
export default Organizations;
